// TSS vite/04 §"Endpoint paths". baseURL already includes /api/v1.

export const clivagePaths = {
    list:   ()    => 'admin/clivages',
    detail: (id)  => `admin/clivages/${id}`,
    bulk:   ()    => 'admin/clivages/bulk',
};
